import { useMutation, useQueryClient } from "@tanstack/react-query";

import { toast } from "@/components/toast/toast-queue";
import apiClient from "@/lib/api/client";

import {
  invalidateStatusChangeQueries,
  scheduleQueueAutomationRefetch,
} from "../../utils/requestInvalidation";

interface UseReopenRequestOptions {
  onError?: (error: Error) => void;
  onSuccess?: () => void;
}

export function useReopenRequest(options: UseReopenRequestOptions = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (requestId: number) =>
      apiClient
        .url(`/requests/${requestId}/toggle-completion`)
        .post({ action: "reopen" })
        .json(),
    onError: (error: Error) => {
      toast.add({
        description: "Please try again later",
        timeout: 2000,
        title: "Error reopening request",
        type: "error",
      });
      options.onError?.(error);
    },
    onSuccess: () => {
      toast.add({
        description: "Request has been reopened successfully.",
        timeout: 2000,
        title: "Request reopened",
        type: "success",
      });
      invalidateStatusChangeQueries(queryClient);
      scheduleQueueAutomationRefetch(queryClient);
      options.onSuccess?.();
    },
  });
}
